export const TOOL_FORM_NAME = 'toolForm';

export const TOOL_WORKING_COPY_ORIGIN = 'WORKING_COPY_ORIGIN_TOOL_EDITOR';
